import 'image-compare-viewer/src/styles/index.scss'

import ImageCompare from 'image-compare-viewer'

import Swiper, { Navigation } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'

class ProjectsGal {
  constructor(elements, settings) {
    this.elements = elements
    this.settings = settings

    this.init()
  }

  defineSlider() {
    new Swiper(this.elements.slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 32,
      navigation: this.elements.navigation,
      allowTouchMove: false
    })
  }

  defineArrowsMoves() {
    if (window.innerWidth < this.settings.breakpoint) {
      this.elements.navigationMoves.mobile.append(this.elements.navigationMoves.wrap)
    } else {
      this.elements.navigationMoves.desktop.append(this.elements.navigationMoves.wrap)
    }

    this.media = {
      query: `(min-width: ${this.settings.breakpoint}px)`
    }
    this.media.watcher = window.matchMedia(this.media.query)

    this.media.watcher.addEventListener('change', event => {
      if (!event.matches) {
        this.elements.navigationMoves.mobile.append(this.elements.navigationMoves.wrap)
      } else {
        this.elements.navigationMoves.desktop.append(this.elements.navigationMoves.wrap)
      }
    })
  }

  init() {
    this.defineSlider()
    if (this.elements.navigationMoves) {
      this.defineArrowsMoves()
    }
  }
}

const projectsSectionsList = document.querySelectorAll('.projects')

projectsSectionsList.forEach(section => {
  const initSection = () => {
    const imageCompareProjectsList = section.querySelectorAll('.project-slide__comparison')
  
    imageCompareProjectsList.forEach((element) => {
      new ImageCompare(element, {
        addCircle: true,
        addCircleBlur: false,
        showLabels: true,
        fluidMode: true,
        labelOptions: {
          before: 'Before',
          after: 'After',
          onHover: false
        },
      }).mount()
    })
  
    new ProjectsGal({
      slider: section.querySelector('.projects-gal'),
      navigation: {
        prevEl: section.querySelector('.projects-arrows__arrow-prev'),
        nextEl: section.querySelector('.projects-arrows__arrow-next'),
      },
      navigationMoves: {
        wrap: section.querySelector('.projects-arrows'),
        mobile: section.querySelector('.projects-gal__arrows'),
        desktop: section.querySelector('.projects__arrows-desktop-place'),
      }
    }, {
      breakpoint: 768
    })
  }

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initSection()
          sectionObserver.disconnect()
        }
      })
    }, {
      threshold: [0.1],
      rootMargin: '250px 0px 250px 0px'
    })

  sectionObserver.observe(section)
})

const projectsGalsList = document.querySelectorAll('.post-body__text-content .projects-gal, .project-body .projects-gal')

projectsGalsList.forEach(section => {
  const imageCompareProjectsList = section.querySelectorAll('.project-slide__comparison')

  imageCompareProjectsList.forEach((element) => {
    new ImageCompare(element, {
      addCircle: true,
      addCircleBlur: false,
      showLabels: true,
      fluidMode: true,
      labelOptions: {
        before: 'Before',
        after: 'After',
        onHover: false
      },
    }).mount()
  })

  new ProjectsGal({
    slider: section,
    navigation: {
      prevEl: section.querySelector('.projects-arrows__arrow-prev'),
      nextEl: section.querySelector('.projects-arrows__arrow-next'),
    }
  }, {
    breakpoint: 768
  })
})